import React, { useEffect, useState } from 'react';
import { Grid, Card, CardContent, Typography, Box } from '@mui/material';
import { Line } from 'react-chartjs-2';
import 'chart.js/auto';
import Navbar from '../Navbar/Navbar';

const Dashboard = () => {
    const [stats, setStats] = useState({
        vistas: 0,
        usuarios: 0,
        clientes: 0,
        pedidos: 0,
        productosNegados: 0,
    });

    const [pedidosPorDia, setPedidosPorDia] = useState([]);
    const [negadosPorDia, setNegadosPorDia] = useState([]);

    useEffect(() => {
        fetchEstadisticas();
    }, []);

    const fetchEstadisticas = async () => {
        try {
            const res = await fetch('https://bibliotecadlago.com/php/estadisticas.php');
            const data = await res.json();

            setStats({
                vistas: data.vistas,
                usuarios: data.usuariosTotales,
                clientes: data.usuariosClientes,
                pedidos: data.totalPedidos,
                productosNegados: data.totalNegados,
            });

            setPedidosPorDia(data.pedidosPorDia);
            setNegadosPorDia(data.negadosPorDia);
        } catch (error) {
            console.error('Error al cargar estadísticas:', error);
        }
    };

    const getChartData = (data, label, color) => ({
        labels: data.map(item => item.fecha),
        datasets: [{
            label,
            data: data.map(item => item.total),
            fill: false,
            backgroundColor: color,
            borderColor: color,
            tension: 0.2,
        }]
    });

    return (
        <>
            <Navbar />
            <Box p={3}>
                <Typography variant="h4" align="center" gutterBottom>
                    Dashboard
                </Typography>

                <Grid container spacing={3} justifyContent="center" mb={6}>
                    {[{
                        label: 'Vistas',
                        value: stats.vistas
                    }, {
                        label: 'Usuarios registrados',
                        value: stats.usuarios
                    }, {
                        label: 'Clientes',
                        value: stats.clientes
                    }, {
                        label: 'Pedidos',
                        value: stats.pedidos
                    }, {
                        label: 'Productos negados',
                        value: stats.productosNegados
                    }].map((item, index) => (
                        <Grid item xs={12} sm={6} md={3} key={index}>
                            <Card sx={{ height: '100%', boxShadow: 3 }}>
                                <CardContent sx={{ textAlign: 'center' }}>
                                    <Typography variant="h6" gutterBottom>
                                        {item.label}
                                    </Typography>
                                    <Typography variant="h3" color="primary">
                                        {item.value}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>

                <Grid container spacing={4} justifyContent="center">
                    <Grid item xs={12} md={10}>
                        <Card sx={{ padding: 3 }}>
                            <Typography variant="h6" align="center" gutterBottom>
                                Pedidos por día
                            </Typography>
                            <Box sx={{ height: 200, width: 400 }}>
                                <Line data={getChartData(pedidosPorDia, 'Pedidos', '#1976d2')} />
                            </Box>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Card sx={{ padding: 3 }}>
                            <Typography variant="h6" align="center" gutterBottom>
                                Productos negados por día
                            </Typography>
                            <Box sx={{ height: 200, width: 400}}>
                                <Line data={getChartData(negadosPorDia, 'Negados', '#d32f2f')} />
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

        </>
    );
};

export default Dashboard;
